<p-fieldset>
    <ng-template pTemplate="header">01 Fausta Casanova Y Loeza</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" ></button>
            <!--<button pButton pRipple label="Validar" icon="pi pi-chevron-plus" class="p-button-success p-mr-2" ></button>
            button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedProducts || !selectedProducts.length"></button-->
        </ng-template>
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>
    <div class="card">

        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>Zona</span>
                        <span class="p-text-bold">0001 México Sur (zona)</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>Coordinación origen</span>
                        <span class="p-text-bold">	0000000003 México Sur (zona)</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>Coordinación destino</span>
                        <span class="p-text-bold">0000000015 México Península</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>Fecha requerimiento</span>
                        <span class="p-text-bold">20211006</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>Tipo de cambio</span>
                        <span class="p-text-bold">20.6408</span>
                    </div>
                </p-panel>
            </div>
        </div>


        <p-tabView [(activeIndex)]="indexTab">
            <p-tabPanel header=" 1) Detalle Solicitud">
                <p-table #dt [value]="listZonesCoord" [rows]="20" [paginator]="true" [globalFilterFields]="['name','country.name','representative.name','status']"
                [(selection)]="selectedProduct" [rowHover]="true" dataKey="storeId" styleClass="p-datatable-responsive-demo"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <h5 class="p-m-0">Lista de Articulos a Solicitar</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                        </span>
                    </div>
                    
                    <br>
                    <p-autoComplete [(ngModel)]="text" [suggestions]="results" (completeMethod)="search($event)" [dropdown]="true" placeholder="Agregar otro articulo"></p-autoComplete>
                    &nbsp;
                    <button pButton pRipple label="Agregar" icon="pi pi-chevron-plus" class="p-button-success p-mr-3" ></button>
                    <span style="float: right;">
                        <p-button label="Siguiente" styleClass="ui-button-warning" (click)="handleNextFirstTab(event)" ></p-button>
                    </span>
                    <br>
                    <br>
                    <span class="p-input-icon-left">
                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!--th pSortableColumn="storeId">id Zona <p-sortIcon field="storeId"></p-sortIcon></th-->
                        <th pSortableColumn="id">ID Articulo <p-sortIcon field="id"></p-sortIcon></th>
                        <th pSortableColumn="descript">Descripción <p-sortIcon field="descript"></p-sortIcon></th>
                        <th pSortableColumn="provedoor">Proveedor <p-sortIcon field="coordName"></p-sortIcon></th>
                        <th pSortableColumn="multiple">multiple_ <p-sortIcon field="multiple"></p-sortIcon></th>
                        <th pSortableColumn="unidadMed">Unidad de med <p-sortIcon field="treastName"></p-sortIcon></th>
                        <th pSortableColumn="cantReq">Cant Requerida <p-sortIcon field="cantReq"></p-sortIcon></th>
                        <th pSortableColumn="cantPen">Cant Pendientes <p-sortIcon field="cantPen"></p-sortIcon></th>
                        <th pSortableColumn="cantEnvio">Cant de envio <p-sortIcon field="cantEnvio"></p-sortIcon></th>
                        <th pSortableColumn="rango">Rango de Folios (11-15,18-19,22,25) <p-sortIcon field="rango"></p-sortIcon></th>
                        <th pSortableColumn="coment">Comentarios <p-sortIcon field="coment"></p-sortIcon></th>
                        <th pSortableColumn="package">Paquetes <p-sortIcon field="package"></p-sortIcon></th>
                        <th style="width:8rem"></th>
                    </tr>
                </ng-template>
                    <ng-template pTemplate="body" let-product let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="product">
                            <!--td>{{zone.storeId}}</td-->
                            <td>
                                {{product.id}}
                            </td>
                            <td>{{product.descript}}</td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="product.provedoor">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.provedoor}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>{{product.multiple}}</td>
                            <td>{{product.unidadMed}}</td>
                            <td>{{product.cantReq}}</td>
                            <td>{{product.cantPen}}</td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" [(ngModel)]="product.cantEnvio">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.cantEnvio}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>{{product.rango}}</td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="product.coment">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.coment}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>{{product.package}}</td>
                            <td style="text-align:center">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(product)" class="p-button-rounded p-button-text"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(product)" class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(product, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            In total there are {{listZonesCoord ? listZonesCoord.length : 0 }} products.
                        </div>
                    </ng-template>
                </p-table>




            </p-tabPanel>
            <p-tabPanel header="2 ) Hoja de despacho, Exportar" [disabled]="secondTabDisabled">
                <div class="layout-invoice-page">
                    <button pButton pRipple type="button" label="Print" icon="pi pi-print" (click)="print()" class="p-mb-3"></button>
                    <span style="float: right;">
                        <button pButton pRipple type="button" class="p-mb-3" label="Regresar"  (click)="handleBackSecondTab($event)"></button>
                        <button pButton pRipple type="button" class="p-mb-3" label="Siguiente" (click)="handleNextSecondTab($event)" ></button>
                    </span>
                    
                
                    <div class="p-grid layout-invoice-content">
                        <div class="p-col-12">
                            <div class="card">
                                <div class="p-d-flex p-jc-between">
                                    <h5>AT´N Fausta Casanova Y Loeza</h5>
                                    <div class="p-d-flex p-flex-column p-ai-end">
                                        <img src="assets/layout/images/logo2x___.png" alt="invoice-logo"/>
                                        <p class="p-mt-1">Diciembre 02/2021</p>
                                        <p class="p-mt-1">Fecha Requerimiento 202111006</p>
                                    </div>
                                </div>
                
                                <div class="p-p-3">
                                    <p-table [columns]="billCols" [value]="billData" styleClass="p-invoice-datatable-responsive p-pb-3">
                                        <ng-template pTemplate="header" let-columns>
                                            <tr>
                                                <th *ngFor="let col of columns">
                                                    {{col.header}}
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                                            <tr>
                                                <td *ngFor="let col of columns">
                                                    <span class="p-column-title">{{col.header}}</span>
                                                    {{rowData[col.field]}}
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                
                                    <p-table [columns]="productCols" [value]="listZonesCoord" styleClass="p-invoice-datatable-responsive p-datatable-sm p-py-6">
                                        <ng-template pTemplate="header" let-columns>
                                            <tr>
                                                <th *ngFor="let col of columns">
                                                    {{col.header}}
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                                            <tr>
                                                <td *ngFor="let col of columns">
                                                    <span class="p-column-title">{{col.header}}</span>
                                                    {{rowData[col.field]}}
                                                </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                
                                    <div class="p-grid">
                                        <!--
                                        <div class="p-col-12 p-md-6">
                                            <p-panel header="BANK">
                                                <div class="p-d-flex p-ai-center p-jc-between p-py-2">
                                                    <span>Bank</span>
                                                    <span class="p-text-bold">BestBank</span>
                                                </div>
                                                <div class="p-d-flex p-ai-center p-jc-between p-pt-2 p-py-2">
                                                    <span>ACCOUNT BENEFICIARY</span>
                                                    <span class="p-text-bold">Edward Williams</span>
                                                </div>
                                                <div class="p-d-flex p-ai-center p-jc-between p-pt-2 p-py-2">
                                                    <span>SWIFT</span>
                                                    <span class="p-text-bold">PJNWBXND</span>
                                                </div>
                                                <div class="p-d-flex p-ai-center p-jc-between p-pt-2 p-py-2">
                                                    <span>IBAN</span>
                                                    <span class="p-text-bold">GB04420235692263866724650931</span>
                                                </div>
                                            </p-panel>
                                        </div>
                                        -->
                                        <div class="p-col-12 p-md-6">
                                            <p-panel header="TOTAL">
                                                <div class="p-grid p-text-right">
                                                    <div class="p-col-10">
                                                        SUBTOTAL
                                                    </div>
                                                    <div class="p-col-2">
                                                        <span class="pink-color">$1304.00</span>
                                                    </div>
                
                                                    <div class="p-col-10">
                                                        <span>VAT</span>
                                                    </div>
                                                    <div class="p-col-2">
                                                        <span class="pink-color">$234.72</span>
                                                    </div>
                
                                                    <div class="p-col-10">
                                                        <span>TOTAL</span>
                                                    </div>
                                                    <div class="p-col-2">
                                                        <span class="pink-color">$1538.72</span>
                                                    </div>
                                                </div>
                                            </p-panel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
               
            </p-tabPanel>
            <p-tabPanel header="3 ) Datos Envio " [disabled]="thirdTabDisabled"  >
                <button pButton pRipple type="button" label="Guardar/Actualizar" icon="pi pi-print" (click)="print()" class="p-mb-3"></button>
                <span style="float: right;">
                    <button pButton pRipple type="button" class="p-mb-3" label="Regresar"  (click)="handleBackThirdTab($event)"></button>
                    <button pButton pRipple type="button" class="p-mb-3" label="Siguiente" (click)="handleNextThirdTab($event)" ></button>
                </span>
                <div class="p-grid">
                    
                    <div class="p-col-12 p-md-6">
                        <div class="card">
                            <h5>Ingrese Datos de envio</h5>
                            <div class="p-fluid">
                                <div class="p-field p-grid">
                                    <label for="firstname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Enviar a:</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="firstname4" type="text" pInputText [disabled]="true"> 
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Dirección</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText [disabled]="true">
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Números Telefonicos</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText [disabled]="true">
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Transfer./Remision asociada</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText [disabled]="true">
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Transporte*</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText >
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Rastreo</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText >
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Paquete</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText >
                                    </div>
                                </div>

                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Peso (KG)</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText >
                                    </div>
                                </div>

                                <div class="p-field p-grid">
                                    <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Fecha de envio*</label>
                                    <div class="p-col-12 p-md-10">
                                        <input id="lastname4" type="text" pInputText >
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                    <div class="p-col-12 p-md-6">
                        <div class="card">
                            <h5>Ingrese Egresos, Coordinación destino</h5>
                                <div class="p-fluid">
                                    <div class="p-field p-grid">
                                        <label for="firstname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Tipo de gasto</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="firstname4" type="text" pInputText>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Concepto, Id Documento ...: *</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="lastname4" type="text" pInputText>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Sub Total *</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="lastname4" type="text" pInputText>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Iva/Impuesto</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="lastname4" type="text" pInputText>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Retención</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="lastname4" type="text" pInputText>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Descuento</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="lastname4" type="text" pInputText>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <label for="lastname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Total</label>
                                        <div class="p-col-12 p-md-10">
                                            <input id="lastname4" type="text" pInputText [disabled]="true">
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="4 ) Confirma envio " [disabled]="fourthTabDisabled"  >
                <span style="float: right;">
                    <button pButton pRipple type="button" class="p-mb-3" label="Regresar"  (click)="handleNextFourthTab($event)"></button>
                    <!--button pButton pRipple type="button" class="p-mb-3" label="Siguiente" (click)="handleNextFourthTab($event)" ></button-->
                </span>
                <div class="p-grid">
                </div>


            </p-tabPanel>



        </p-tabView>
    

        
</div>

</p-fieldset>